import { DirectSend } from 'iconsax-reactjs';
import { memo, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { call } from '@/services/call';
import { logger } from '@/services/logger';
import { showUIAlert } from '@/store/features/ui/slice';
import { AlertTypes } from '@/store/features/ui/types';
import { StyledScreenShareToggleButton } from './styled';

const ScreenShareToggleButton = () => {
  const { t } = useTranslation();

  const dispatch = useDispatch();

  const [active, setActive] = useState(false);

  const isTogglingScreen = useRef(false);

  const toggle = async () => {
    try {
      if (call.remoteScreenTrack) {
        dispatch(
          showUIAlert({
            title: t('screen_sharing_in_progress'),
            message: t('screen_sharing_conflict'),
            type: AlertTypes.error,
          }),
        );
        return;
      }

      if (active) {
        call.stopShareScreen();
        setActive(false);

        return;
      }

      if (!isTogglingScreen.current) {
        isTogglingScreen.current = true;
        const track = await call.startShareScreen(() => {
          setActive(false);
        });

        if (track) {
          setActive(true);
        }
      }
    } catch (error) {
      logger.error(error);
    } finally {
      isTogglingScreen.current = false;
    }
  };

  return (
    <StyledScreenShareToggleButton $active={active} onClick={toggle}>
      <DirectSend variant={active ? 'Bold' : 'Outline'} />
    </StyledScreenShareToggleButton>
  );
};

export default memo(ScreenShareToggleButton);
